import { SchoolDTO } from '../SchoolProfile/SchoolDetails';
import { get } from '../../../shared/api';
import { PagedResponseDTO, PageSearchQueryConfig } from '../../../shared/constants';
import { generateSearchQuery } from '../../../shared/helpers';

export const getSchoolsRequest = (pageConfig: PageSearchQueryConfig = {}): Promise<PagedResponseDTO<SchoolDTO[]>> => {
  const query = generateSearchQuery(pageConfig);
  return get<PagedResponseDTO<SchoolDTO[]>>(`/schools${query}`);
};
